export default __webpack_public_path__ + "static/media/Dosis-Book.d4d759f9.ttf";